import * as service from './service'
export default {
  namespace: 'levelSysLevelDesc',
  state: {
    develDescData: {}
  },
  effects: {
    * courierLevelDesc ({ payload }, { call, put }) {
      const res = yield call(service.courierLevelDesc, payload)
      yield put({
        type: 'save',
        payload: {
          develDescData: res.data.data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
